import { render, staticRenderFns } from "./EditPageBonusCard.vue?vue&type=template&id=27a22ecc"
import script from "./EditPageBonusCard.vue?vue&type=script&lang=js"
export * from "./EditPageBonusCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports